import { useState } from 'react';
import { ClipboardDocumentCheckIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

interface CopyButtonProps {
  text: string;
  small?: boolean;
}

export default function CopyButton({ text, small }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback: ignore
    }
  };

  if (small) {
    return (
      <button
        type="button"
        onClick={handleCopy}
        title="Copy topic"
        className="flex-shrink-0 p-1 rounded text-muted hover:text-primary transition-colors"
      >
        {copied ? (
          <CheckCircleIcon className="w-4 h-4 text-semantic-up" />
        ) : (
          <ClipboardDocumentCheckIcon className="w-4 h-4" />
        )}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs transition-colors ${
        copied
          ? 'border-semantic-up/30 text-semantic-up bg-semantic-up/5'
          : 'border-hairline text-muted hover:border-primary/50 hover:text-primary'
      }`}
    >
      {copied ? (
        <>
          <CheckCircleIcon className="w-3.5 h-3.5" />
          Copied!
        </>
      ) : (
        <>
          <ClipboardDocumentCheckIcon className="w-3.5 h-3.5" />
          Copy
        </>
      )}
    </button>
  );
}